import React from 'react';
import LegalDisclosure from '../legalDisclosure/LegalDisclosure';
import ModalImage from '../modal/ModalImage';

const OptionDetail = ({
  detail,
  showImageDisclosure = false,
  option,
  showLegalDisclosure = false,
}) => {
  const { largeImageUrl, shortCfd } = option;

  return (
    <>
      {showLegalDisclosure && (
        <LegalDisclosure
          className="legal-disclosure--option-details"
          showAsStatic
        />
      )}
      <div className="option-detail__container">
        {detail}
        <ModalImage
          url={largeImageUrl ? largeImageUrl : null}
          alt={shortCfd || 'Option Detail'}
          showImageDisclosure={showImageDisclosure}
        />
      </div>
    </>
  );
};

export default OptionDetail;
